import React from 'react'

import { useSelector } from 'react-redux'

import useStyles from './priority-connect-v1.style'

import ActionButton from '@components/action-button/action-button.component'
import BigActionButton from '@components/big-action-button/big-action-button.component'
import BodyItem from '@components/body-item/body-item.component'
import CardDropdown from '@components/card-dropdown/card-dropdown.component'
import CardMap from '@components/card-map/card-map.component'
import CarouselContainer from '@components/carousel-container/carousel-container.component'
import ContactActionButton from '@components/contact-button/contact-button.component'
import UpdatedByContainer from '@components/updated-by-container/updated-by-container.component'

import {
  Card,
  Carousel,
  CardBody,
  CardHeader,
  GUN_GRAY,
  Badge,
  Title,
  WHITE
} from '@omnilert/components'

const PriorityConnectV1 = (props) => {
  const { message } = props

  const { collection, documentId } = message

  const document = useSelector(
    ({ firestore: { data } }) =>
      data[collection] && data[collection][documentId]
  )

  const {
    actionButton,
    actions,
    body,
    contactActions,
    header,
    location,
    meta,
    updatedBy
  } = document

  const actionTaken = meta?.actionTaken

  const isResolved = meta?.isResolved

  const hideActions = isResolved || actionTaken

  const variant = header?.data?.variant

  const hasMultipleActions = actions?.length > 1

  const titleColor = variant === 'invalid' ? GUN_GRAY : WHITE

  const classes = useStyles({ hasMultipleActions })

  if (!document) return null

  return (
    <Card className={classes.card}>
      {header && (
        <CardHeader
          className={classes.cardHeader}
          type={variant}
        >
          <Title
            className={classes.title}
            color={titleColor}
            size='sm'
          >
            {header.data.title}
          </Title>
          <CardDropdown
            data={header?.data}
            direction='bottom'
          />
        </CardHeader>
      )}

      {location && <CardMap locations={location?.data} />}

      {isResolved && <Badge className={classes.badge}>RESOLVED</Badge>}

      {body && (
        <CardBody className={classes.cardBody}>
          {body.data.map((item, index) => (
            <BodyItem
              key={index}
              item={item}
            />
          ))}
        </CardBody>
      )}

      {updatedBy && <UpdatedByContainer
        data={updatedBy?.data}
        showDivider
      />}

      {(contactActions || actions) && (
        <CarouselContainer>
          {contactActions && (
            <Carousel className={classes.carousel}>
              {contactActions.data.map((data) => (
                <ContactActionButton
                  key={`contactAction-${data.id}`}
                  data={data}
                  documentId={documentId}
                />
              ))}
            </Carousel>
          )}
          <Carousel
            className={classes.actionCarousel}
            hideActions={hideActions}
          >
            {actions.data.map((data) => (
              <ActionButton
                key={`action-${data.id}`}
                data={data}
                documentId={documentId}
              />
            ))}
          </Carousel>
        </CarouselContainer>
      )}

      {actionButton &&
        actionButton.data.map((data) => (
          <BigActionButton
            key={`action-${data.id}`}
            data={data}
            documentId={documentId}
          />
        ))}
    </Card>
  )
}

export default PriorityConnectV1
